import { Component } from '@angular/core';
import { languages } from 'src/app/shared/constants/app-enums';
import { EventService } from 'src/app/services/event.service';
import { TranslateService } from '@ngx-translate/core';


export var selectedLang: string;
@Component({
  selector: 'app-airdrop',
  templateUrl: './airdrop.component.html',
  styleUrls: ['./airdrop.component.scss']
})
export class AirdropComponent {
  currentLanguage: any;
  languagesList: Array<any> = languages;
  items = [
    {
      name: "airdrop_item_name1",
      badge: "airdrop_item_badge1"
    },
    {
      name: "airdrop_item_name2",
      badge: "airdrop_item_badge2"
    },
    {
      name: "airdrop_item_name3",
      badge: "airdrop_item_badge3"
    },
    {
      name: "airdrop_item_name4",
      badge: "airdrop_item_badge4"
    },
    {
      name: "airdrop_item_name5",
      badge: "airdrop_item_badge5"
    },
    {
      name: "airdrop_item_name6",
      badge: "airdrop_item_badge6"
    },
    {
      name: "airdrop_item_name7",
      badge: "airdrop_item_badge7"
    },
  ]

  cards = [
    {
      img: "./assets/images/card-1.svg",
      title: "airdrop-card1-title",
      desc: "airdrop-card1-desc",
    },
    {
      img: "./assets/images/card-2.svg",
      title: "airdrop-card2-title",
      desc: "airdrop-card2-desc",
    },
    {
      img: "./assets/images/card3-airdrop.svg",
      title: "airdrop-card3-title",
      desc: "airdrop-card3-desc",
    },
  ]
  constructor(
    private eventService: EventService,
    private translate: TranslateService,
  ) {
    selectedLang = this.eventService.getNewLang() || 'en';
  }
  ngOnInit(): void {
    console.log("selected lang", selectedLang);
    this.translate.setDefaultLang(selectedLang);
    this.translate.use(selectedLang);
    this.eventService.setLang(selectedLang);
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      selectedLang = this.languagesList.filter(
        (x) => x.value === this.currentLanguage
      )[0];
    }

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

  }

  data: any = [
    {
      parentName: 'air-faq1',
      childProperties: [
        {
          propertyName: 'air-faq_para1',
          links: [''],
        },
      ],
    },
    {
      parentName: 'air-faq2',
      childProperties: [{
        propertyName: 'air-faq_para2',
        links: ['']
      }],
    },
    {
      parentName: 'air-faq3',
      childProperties: [{
        propertyName: 'air-faq_para3',
        links: ['']
      }],
    },
    {
      parentName: 'air-faq4',
      childProperties: [
        {
          propertyName: 'air-faq_para4',
          links: [''],
        },
      ],
    },
    {
      parentName: 'air-faq5',
      childProperties: [
        {
          propertyName: 'air-faq_para5',
          links: [''],
        },
      ],
    },
    {
      parentName: 'air-faq6',
      childProperties: [{
        propertyName: 'air-faq_para6',
        links: ['']
      }],
    },

    {
      parentName: 'air-faq7',
      childProperties: [{
        propertyName: 'air-faq_para7',
        links: ['']
      }],
    },
    {
      parentName: 'air-faq8',
      childProperties: [{
        propertyName: 'air-faq_para8',
        links: ['']
      }],
    },
    {
      parentName: 'air-faq9',
      childProperties: [{
        propertyName: 'air-faq_para9',
        links: ['']
      }],
    },
    {
      parentName: 'air-faq10',
      childProperties: [{
        propertyName: 'air-faq_para10',
        links: ['']
      }],
    },
  ];

  // styles: Partial<CSSStyleDeclaration> = {
  //   width: '224px',
  //   height: '224px',
  //   margin: '0 auto',
  //   scale: '1.8',
  // };

  toggleAccordian(event: any, index: any) {
    const element: HTMLElement = event.target;
    const panel: HTMLElement | null = element.nextElementSibling as HTMLElement | null;
    // Close previously open accordions
    this.data.forEach((item: any, i: number) => {
      if (i !== index && item.isActive) {
        item.isActive = false;
        const prevPanel: HTMLElement | null = document.querySelectorAll('.panel')[i] as HTMLElement | null;
        if (prevPanel) {
          prevPanel.style.maxHeight = ""; // Set to empty string
        }
        const prevElement: HTMLElement | null = document.querySelectorAll('.accordion')[i] as HTMLElement | null;
        if (prevElement) {
          prevElement.classList.remove('active');
        }
      }
    });
    // Toggle the clicked accordion
    element.classList.toggle('active');
    this.data[index].isActive = !this.data[index].isActive;
    if (panel) {
      if (panel.style.maxHeight) {
        panel.style.maxHeight = ""; // Set to empty string
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }
  }
}
